import { EmptyState } from 'react-common'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useLearnerNavigationVisibilitySettings } from '@/hooks/useLearnerNavigationVisibilitySettings'
import accessGuard from '@/themes/alemira/img/access-guard.png'
import styles from './EmptyCourses.module.scss'

export const EmptyCourses = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const learnerNavigationVisibilitySettings = useLearnerNavigationVisibilitySettings()
  const catalogEnabled = learnerNavigationVisibilitySettings.catalog

  const onClickButton = () => {
    navigate('/catalog')
  }

  return (
    <div className={styles.wrapper}>
      <EmptyState
        imgSrc={accessGuard}
        title={t('emptyCourses.title')}
        description={catalogEnabled ? t('emptyCourses.description') : t('emptyCourses.catalogDisabledDescription')}
        buttonText={t('emptyCourses.buttonText')}
        onClickButton={onClickButton}
        showButton={catalogEnabled}
      />
    </div>
  )
}
